var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableReverseModelCrossicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.9,
    width: 43.2,
    height: 43.2,
    rx: 4.6,
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9979 22.5001L30.0896 16.4226C30.3563 16.1558 30.5062 15.794 30.5062 15.4167C30.5062 15.0395 30.3563 14.6777 30.0896 14.4109C29.8228 14.1441 29.461 13.9943 29.0837 13.9943C28.7065 13.9943 28.3447 14.1441 28.0779 14.4109L22.0004 20.5026L15.9229 14.4109C15.6561 14.1441 15.2943 13.9943 14.9171 13.9943C14.5398 13.9943 14.178 14.1441 13.9112 14.4109C13.6445 14.6777 13.4946 15.0395 13.4946 15.4167C13.4946 15.794 13.6445 16.1558 13.9112 16.4226L20.0029 22.5001L13.9112 28.5776C13.7785 28.7093 13.6731 28.8659 13.6011 29.0386C13.5292 29.2112 13.4922 29.3964 13.4922 29.5834C13.4922 29.7704 13.5292 29.9556 13.6011 30.1282C13.6731 30.3008 13.7785 30.4575 13.9112 30.5892C14.0429 30.722 14.1996 30.8274 14.3723 30.8993C14.5449 30.9712 14.7301 31.0083 14.9171 31.0083C15.1041 31.0083 15.2893 30.9712 15.4619 30.8993C15.6345 30.8274 15.7912 30.722 15.9229 30.5892L22.0004 24.4976L28.0779 30.5892C28.2096 30.722 28.3663 30.8274 28.5389 30.8993C28.7116 30.9712 28.8967 31.0083 29.0837 31.0083C29.2708 31.0083 29.4559 30.9712 29.6286 30.8993C29.8012 30.8274 29.9579 30.722 30.0896 30.5892C30.2223 30.4575 30.3277 30.3008 30.3997 30.1282C30.4716 29.9556 30.5086 29.7704 30.5086 29.5834C30.5086 29.3964 30.4716 29.2112 30.3997 29.0386C30.3277 28.8659 30.2223 28.7093 30.0896 28.5776L23.9979 22.5001Z",
    fill: "#232738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableReverseModelCrossicon);
export default __webpack_public_path__ + "static/media/available-reverse-model-crossicon.32c439e6a3f984cb600db03a90049a0c.svg";
export { ForwardRef as ReactComponent };